import Home from './home.svg';
import Divider from './nav-divider.svg';
import Mag from './magnifying-glass.ded40be2.svg';
import { Button } from './Primary.styles';

export const Primary = ({linksData, searchData}) => {
    const genNavItem = () => {
        return linksData.map((link, i) => {
            if (link.Name === "Home" || link.Name === "Facilities & Offices") {
                if (link.Name === "Home") {
                    return(<li key={i}><a href={link.Url} title={link.Name}><img id="home-icon" src={Home} aria-hidden="true" alt="Home" />{link.Name}</a></li>)
                } else {
                    return(<li key={i}><a href={link.Url} title={link.Name}>{link.Name}</a></li>)    
                }
            } else {
                if (link.Name !== "News") {
                    return(<li key={i} className="with-divider"><a href={link.Url} title={link.Name}>{link.Name}</a><img className='divider' src={Divider} aria-hidden="true" alt="Divider" /></li>)
                } else {
                    return(<li key={i}><a href={link.Url} title={link.Name}>{link.Name}</a></li>)
                }
                
            }
        })
    }

    const genForm = () => {
        return(
        <li className="banner-search col-9">
            <form action={searchData} className="site-search" method="post">
                <label className="accessibility-hidden" htmlFor="search-term">Search Term</label>
                <input id="search-term" type="text" name="search" placeholder="Search the Site" />
                <Button background={Mag} type="submit"><span className="accessibility-hidden">search</span></Button>
            </form>
        </li>
        )
    }

    return(<ul id="primary-page-links" className="content-wrapper">{genNavItem()}{genForm()}</ul>)
}